/**
 * @desc 钉钉对私账户信息-导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  body: defs.basics.StaffPaymentInfoRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basic/staffPaymentInfo/exportStaffPaymentInfoExcel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
